<div class="error-screen ids-p-5">
  <div>
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M37.1519 41.9519H13.1519C9.83986 41.9519 7.15186 39.2639 7.15186 35.9519V11.9519C7.15186 8.6399 9.83986 5.9519 13.1519 5.9519H37.1519C40.4639 5.9519 43.1519 8.6399 43.1519 11.9519V35.9519C43.1519 39.2639 40.4639 41.9519 37.1519 41.9519ZM13.1519 9.4559C11.7839 9.4559 10.6559 10.5839 10.6559 11.9519V35.9519C10.6559 37.3199 11.7839 38.4479 13.1519 38.4479H37.1519C38.5199 38.4479 39.6479 37.3199 39.6479 35.9519V11.9519C39.6479 10.5839 38.5199 9.4559 37.1519 9.4559H13.1519ZM26.9039 33.9599H23.3999V30.1679H26.9039V33.9599ZM26.9039 27.3359H23.3999V13.9679H26.9039V27.3359Z"
        fill="#B71C1C"
      />
    </svg>
  </div>

  <h1 class="ids-mt-4">Desculpe, não conseguimos carregar as informações</h1>
  <p class="ids-mt-4">Estamos verificando o que aconteceu. Por favor, tente novamente</p>
  <button
    id="navigate-home"
    class="ids-mt-4 button-container__back ids-text-label-large-bold"
    (click)="navigateToHome()"
    variant="secondary"
    idsMainButton
  >
    Ir para tela inicial
  </button>
  <button
    id="try-again"
    class="ids-mt-4 button-container__back ids-text-label-large-bold"
    *ngIf="errorCount < 2"
    (click)="tryAgainAction()"
    idsMainButton
  >
    Tente novamente
  </button>
</div>
